import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import { set } from "react-hook-form";


const QuestionsIndex = () => {
	const [centers, setCenters] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const [picture, setPicture] = useState(null);
	const auth = useSelector(state => state.auth.user);

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "الاسئله",
				breadcrumb: "الاسئله",
				button: {
					show: true,
					text: "اضافة سؤال جديد",
					link: "/aboutPage/questions/create",
				},
			})
		);
		
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/questions/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCenters(response.data.data[0].categories[0].posts.filter((center) => center.id !== 415));
				setPicture(response.data.data[0].categories[0].posts.find(center => center?.id === 415)?.data?.image);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});

			
			
			
	};

	const columns = [
		{
			name: "ID",
			selector: "id",
			sortable: true,
		},
		{
			name: "العنوان",
			sortable: true,
			cell: row => {
				return row.data?.title?.ar;
			},
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/aboutPage/questions/show/${row.id}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfirmDelete(row.id)}
						>
							<i className="fas fa-trash" />
						</button>
					</li>
				</ul>
			),
		},
	];

	const handleConfirmDelete = questionId => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteCenter(questionId),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteCenter = questionId => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${questionId}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};
	const handlePicture = (e) => {
		e.preventDefault();
		const fileInput = document.querySelector("#picture");


		if (fileInput.files[0]) {
			const data = new FormData();
			data.append("file", fileInput.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}).then(response => {
					setPicture(response.data.data.name);
					setLoading(false);
					toast.success("تم رفع الصورة بنجاح!");
				}).catch(error => {
					console.log(error);
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		}
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (picture ) {
			setLoading(true);


			const data = {
				image: picture
			};
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/posts/${415}`,
					{
						admin_id: auth.id,
						category_id: 22,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {

					toast.success("تم اضافة الصوره بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});


		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<>
			<section>
			
			<form onSubmit={handleSubmit}>
				
					<div className="row mx-auto">
						<div className="form-item col-12 ">
							<label>صورة </label>
							<input type="file" onChange={handlePicture} id="picture" />
							<div className="img-holder">
								<img src={picture ? process.env.REACT_APP_MAIN_URL + picture : userPlaceholder} alt="avatar" className="imagePreview" />
							</div>
						</div>
						
						<div className="form-item">
							<button type="submit" className="bt bt-success btn-block">حفظ</button>
						</div>
					
				</div>
			</form>

				{loading && <Loader />}
				<div className="datatable">
					<DataTableExtensions columns={columns} data={centers}>
						<DataTable
							noHeader
							defaultSortField="id"
							defaultSortAsc={false}
							pagination
							highlightOnHover
							direction="rtl"
							striped
						/>
					</DataTableExtensions>
				</div>
			</section>
		</>
	);
};

export default QuestionsIndex;
